export default __webpack_public_path__ + "static/media/icon-chart-column.384f0389.svg";